export const fmtY = (n) => "¥" + Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const fmtUsd = (n) => "$" + Number(n || 0).toLocaleString("en-US", { maximumFractionDigits: 0 });
export const L = (item, zh) => (zh ? item[1] : item[2]);
export const numCls = "w-24 text-xs rounded border border-slate-200 px-1.5 py-1 text-right";
export const th = "text-left text-[11px] font-semibold text-slate-400 px-2 py-2 whitespace-nowrap";
export const td = "px-2 py-1.5 whitespace-nowrap text-xs";
export const btnDark = "text-[11px] rounded-full bg-slate-800 hover:bg-slate-900 text-white font-semibold px-3 py-1 disabled:opacity-50";
export const btnBrand = "text-[11px] rounded-full bg-brand-500 hover:bg-brand-600 text-white font-semibold px-3 py-1 disabled:opacity-50";
export const btnLine = "text-[11px] rounded-full border border-slate-200 text-slate-600 hover:bg-slate-50 font-semibold px-3 py-1 disabled:opacity-50";
export const errMsg = (e, fb) => e?.response?.data?.detail || fb;
export const STATUS = {
  none: { zh: "未生成", en: "Not generated", cls: "bg-slate-100 text-slate-500" },
  draft: { zh: "草稿", en: "Draft", cls: "bg-amber-100 text-amber-700" },
  confirmed: { zh: "已确认", en: "Confirmed", cls: "bg-emerald-100 text-emerald-700" },
};

export async function downloadFile(api, url, filename, params) {
  const res = await api.get(url, { params, responseType: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(res.data);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}

export async function blobErr(err, fb) {
  try { return JSON.parse(await err.response.data.text()).detail || fb; } catch { return errMsg(err, fb); }
}
